import {
  SpecialQualifications,
  type WorkerShoppableQualification,
} from "@clipboard-health/contract-worker-app-bff";

export const qualificationSubstitutions: Partial<
  Record<SpecialQualifications, SpecialQualifications[]>
> = {
  [SpecialQualifications.NURSE]: [SpecialQualifications.RN, SpecialQualifications.LVN],
};

export function isValidQualificationName(
  qualificationName: string
): qualificationName is SpecialQualifications {
  return qualificationName in SpecialQualifications;
}

export function substituteQualification(
  qualificationName: string,
  workerOptions: string[]
): string {
  if (!isValidQualificationName(qualificationName)) {
    return qualificationName;
  }

  const substitutions = qualificationSubstitutions[qualificationName];
  const firstMatch = substitutions?.find((q) => workerOptions.includes(q));

  return firstMatch ?? qualificationName;
}

export function isCustomWorkerShoppableQualification(
  workerShoppableQualification: WorkerShoppableQualification
): boolean {
  const { data: qualification } = workerShoppableQualification.relationships.qualification;
  return qualification.name !== qualification.baseQualificationName;
}
